import imageCompression from "browser-image-compression";

export const compressFile = async (file) => {
  if (!file) return null;
  try {
    const options = {
      maxSizeMB: 1, // Set the maximum size in MB
      maxWidthOrHeight: 1920, // Set the maximum width or height
      useWebWorker: true, // Use a web worker for better performance
    };

    const compressedBlob = await imageCompression(file, options);
    // browser-image-compression returns a Blob (or File without original name).
    // Reconstruct a File to preserve file.name and extension for FormData uploads.
    return new File([compressedBlob], file.name, {
      type: compressedBlob.type || file.type,
      lastModified: Date.now(),
    });
  } catch (error) {
    console.error('Error compressing image:', error);
    return null;
  }
};
